import z from "zod";

export const AgentPerformanceLeaderboardSortMetricSchema = z.enum([
    "gross",
    "net",
    "total",
    "totalTime",
    "green",
    "yellowCalls",
    "redCalls",
    "overallScore",
]);

export const AgentPerformanceDatePresetSchema = z.enum([
    "today",
    "yesterday",
    "custom_day",
    "last_week",
    "custom_week",
    "last_month_match_dow",
    "custom_month",
    "custom_range",
    // Legacy values from earlier date picker iterations
    "custom",
]);

export const AgentPerformanceComparisonSchema = z.enum([
    "none",
    "previous_period",
    "previous_period_match_dow",
    "custom",
]);

/** Invalid individual params fall back to undefined so one bad value does not wipe the search. */
export const AgentPerformanceDashboardSearchSchema = z.object({
    preset: AgentPerformanceDatePresetSchema.optional().catch(undefined),
    comparison: AgentPerformanceComparisonSchema.optional().catch(undefined),
    start: z.string().optional().catch(undefined),
    end: z.string().optional().catch(undefined),
    comparisonStart: z.string().optional().catch(undefined),
    comparisonEnd: z.string().optional().catch(undefined),
    team: z.string().optional().catch(undefined),
    teamLeads: z.enum(["true", "false"]).optional().catch(undefined),
    rankBy: AgentPerformanceLeaderboardSortMetricSchema.optional().catch(undefined),
});

export type AgentPerformanceDashboardSearch = z.infer<typeof AgentPerformanceDashboardSearchSchema>;

export function parseAgentPerformanceDashboardSearch(raw: unknown): AgentPerformanceDashboardSearch {
    const result = AgentPerformanceDashboardSearchSchema.safeParse(raw ?? {});
    return result.success ? result.data : {};
}
